module.exports = __webpack_public_path__ + "feb6c69075ba4832441ec041c76e1a9c.pdf";